import {useQuery} from "@tanstack/react-query";
import {ISailDimension} from "../declarations";
import {createApiClient} from "../utilities/apiClient";

const getSailInfoSizing=async (guid: string): Promise<ISailDimension[]> => {
    const axiosSailTag=createApiClient();
    const response=await axiosSailTag.get<ISailDimension[]>(`/api/SailInfo/GetSailInfoSizing/${encodeURIComponent(guid)}`);
    return response.data;
};

export const useGetSailInfoSizing=(guid: string) =>
    useQuery<ISailDimension[]>({
        queryKey: [
            "GetSailInfoSizing",
            {
                guid: guid??null
            }
        ],
        queryFn: () => {
            if(!guid?.trim()) {
                throw new Error("Invalid params for GetSailInfoSizing");
            }
            return getSailInfoSizing(guid);
        },
        enabled: Boolean(guid?.trim()),
        refetchOnWindowFocus: true,
        retry: false,
        placeholderData: []
    });